/* eslint-disable jsdoc/require-jsdoc */
import React, { ReactElement } from 'react';
import DashboardWidgetContainer from '../../components/DashboardWidgetContainer';
import FloorMapCarousel from '../../components/FloorMapCarousel';
import { DashboardDataFilter, Group } from '../../constants/telosair-interfaces';

interface MapContainerProps {
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<'map' | 'histogram'>>;
  extendedLabel: string;
  groups: Group[];
  loading: boolean;
  dataFilter: DashboardDataFilter | null;
  setDataFilter?: (filter: DashboardDataFilter | null) => void;
}

export default function MapContainer({
  expanded,
  setExpanded,
  extendedLabel,
  groups,
  loading,
  dataFilter,
  setDataFilter
}: MapContainerProps): ReactElement {
  return (
    <DashboardWidgetContainer
      name="map"
      title="Floor Map"
      expanded={expanded}
      setExpanded={setExpanded}
      extendedLabel={extendedLabel}
    >
      <FloorMapCarousel
        groups={groups}
        loading={loading}
        dataFilter={dataFilter}
        setDataFilter={setDataFilter}
      />
    </DashboardWidgetContainer>
  );
}
